import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { EnumDisplayCell } from "app/static/frontend/sheets/components/cells/MantineCells/EnumDisplayCell"
import { EnumSelectCell } from "app/static/frontend/sheets/components/cells/MantineCells/EnumSelectCell"
import { patchColumnData } from "app/static/frontend/sheets/sheet-action-creators"

const RSVPStatusCellComponent = ({ editing, cellValue, ...props }) => {
    // We can't edit the RSVP status of someone who hasn't been invited to an event
    if (editing && cellValue) {
        return (
            <EnumSelectCell
                choices={DjangIO.app.custom_event.types.RSVPStatus}
                item={DjangIO.app.custom_event.types.RSVPStatus.by_value(cellValue)}
                {...props}
            />
        )
    } else {
        return (
            <EnumDisplayCell
                choices={DjangIO.app.custom_event.types.RSVPStatus}
                item={DjangIO.app.custom_event.types.RSVPStatus.by_value(cellValue)}
                {...props}
            />
        )
    }
}

RSVPStatusCellComponent.propTypes = {
    cellValue: PropTypes.number,
    editing: PropTypes.bool.isRequired,
}

export const RSVPStatusCell = connect(null, { patchColumnData })(RSVPStatusCellComponent)
